import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=2a96a93a&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=2a96a93a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96a93a",
  null
  
)

export default component.exports